import { render, staticRenderFns } from "./InitialQuestion.vue?vue&type=template&id=1139de02&"
import script from "./InitialQuestion.vue?vue&type=script&lang=ts&"
export * from "./InitialQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports